import React, { useEffect, useContext } from "react";
import { ScaleLinear } from "d3-scale";
import { DateFilterContext } from "../../context";
import { createTickProps } from "../../hooks";
import { getNextTick } from "../../uitls";
import { Layer } from "../../reducers";
import { getStatistic } from "../../../../resources/statistics";
import { getKeyData } from "./utils";

interface BarInterface {
  date: Date;
  x: number;
  extentDomain: (date: Date, data: { key: string; value: number }) => void;
  yScale: ScaleLinear<number, number>;
  layer: Layer;
  data: [number, number];
}

const getFiniteNumber = (number: number): number => (isFinite(number) ? number : 0);

export default ({ date, x, extentDomain, yScale, layer, data = [0, 0] }: BarInterface) => {
  const { durationInterval, rangeDate, tickWidth } = useContext(DateFilterContext);
  const svgHeight = 74;
  const nextDate = getNextTick(rangeDate, durationInterval, date);
  const props = createTickProps(layer, date, nextDate);
  const { data: statisicData, loading, error } = getStatistic.use({ input: props });
  const value = statisicData?.statisticsResult?.[0]?.value;

  const y = loading ? 0 : yScale(data[0]);
  const yCoordiate = getFiniteNumber(y);
  const scaleHeight = loading ? 26 : yScale(data[1]) - yCoordiate;
  const height = getFiniteNumber(scaleHeight);

  useEffect(() => {
    if (!loading) {
      extentDomain(date, { key: getKeyData(layer), value });
    }
  }, [date, extentDomain, layer, loading, value]);

  if (error) {
    return (
      <rect
        fill="red"
        x={x + 1}
        width={tickWidth - 1}
        y={0}
        height={height}
        transform={`translate(0, ${svgHeight - 31 - height})`}
      >
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0s"
          dur="0.7s"
          repeatCount="indefinite"
        />
      </rect>
    );
  }

  return loading ? (
    <rect
      fill="grey"
      x={x + 1}
      width={tickWidth - 1}
      y={0}
      height={height}
      transform={`translate(0, ${svgHeight - 31 - height})`}
    >
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .2; 1"
        begin="0s"
        dur="0.7s"
        repeatCount="indefinite"
      />
    </rect>
  ) : (
    <rect
      rx={1}
      ry={1}
      fill={layer.aggregationColor.toString("hex")}
      x={x + 1}
      width={tickWidth - 1}
      y={-yCoordiate}
      height={height}
      transform={`translate(0, ${svgHeight - 31 - height})`}
    />
  );
};
